import { TRecommendation } from '../../types/recommendation';
import { IApplicationState } from '../../types/redux';
import { createSelector } from 'reselect';

export const selectRecommendations = (state: IApplicationState) => state.recommendations?.recommendations;

export const selectRecommendationById = (id: number) =>
  createSelector(
    [selectRecommendations],
    (recommendations): TRecommendation =>
      recommendations?.find(({ offerId }) => offerId === id) || ({} as TRecommendation),
  );
